import consola from 'consola'
import { computed, ref } from 'vue'
import { getBranchLabel, getReadyInstitutionId } from '@entities/institution'

const logger = consola.withTag('admin:branch-options')

export interface AdminBranchOption {
  label: string
  value: number
}

/**
 * Филиалы заведения для селектов админки.
 *
 * Загрузка филиалов повторялась в каждой форме, где нужна привязка (комбо, товары,
 * теперь добавки и копирование), причём в разных формах `value` был то строкой, то
 * числом — и бэк, ждущий number[], молча получал строки. Здесь один источник и один тип.
 */
export function useAdminBranchOptions() {
  const branches = ref<AdminBranchOption[]>([])
  const loading = ref(false)

  const labelById = computed(
    () => new Map(branches.value.map(branch => [branch.value, branch.label])),
  )

  /** Подпись филиала по id — для колонок списка и отчётов копирования. */
  const labelOf = (id: number | string): string =>
    labelById.value.get(Number(id)) ?? `Филиал #${id}`

  const load = async (): Promise<void> => {
    try {
      loading.value = true
      const { APIAdminInstitution } = await import('~/fsd-pages/admin/api')
      const institutionId = await getReadyInstitutionId()
      const institution = await APIAdminInstitution.getInstitutionWithBranches(institutionId)

      branches.value = (institution.branches ?? []).map(branch => ({
        label: getBranchLabel(branch),
        value: Number(branch.id),
      }))
    }
    catch (error) {
      logger.error('Не удалось загрузить филиалы заведения:', error)
      branches.value = []
    }
    finally {
      loading.value = false
    }
  }

  return { branches, loading, labelOf, load }
}
